import { inject, Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'highlight',
  standalone: true,
  pure: true
})
export class HighlightPipe implements PipeTransform {
  readonly #sanitizer= inject(DomSanitizer);

  transform(value: string, search: string): SafeHtml {
    if (!search || !value) return value || '';

    const escapedSearch = search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`(${escapedSearch})`, 'gi');
    const highlighted = value.replace(regex, '<mark>$1</mark>');

    return this.#sanitizer.bypassSecurityTrustHtml(highlighted);
  }
}
